export var Placement;
(function (Placement) {
    Placement["UNKNOWN"] = "UNKNOWN";
    Placement["HOME_PAGE"] = "HOME_PAGE";
    Placement["SIDEBAR"] = "SIDEBAR";
})(Placement || (Placement = {}));
export var SectionType;
(function (SectionType) {
    SectionType["UNKNOWN"] = "UNKNOWN";
    SectionType["CATEGORY_CAROUSEL"] = "CATEGORY_CAROUSEL";
    SectionType["SIDEBAR_TITLE"] = "SIDEBAR_TITLE";
    SectionType["SIDEBAR_DIVIDER"] = "SIDEBAR_DIVIDER";
    SectionType["COLLECTION_LINK"] = "COLLECTION_LINK";
    SectionType["CATEGORY_LINK"] = "CATEGORY_LINK";
    SectionType["APP_GROUP"] = "APP_GROUP";
})(SectionType || (SectionType = {}));
export var AppGroupType;
(function (AppGroupType) {
    AppGroupType["UNKNOWN"] = "UNKNOWN";
    AppGroupType["COLLECTION"] = "COLLECTION";
    AppGroupType["PROMO"] = "PROMO";
})(AppGroupType || (AppGroupType = {}));
export var PricingLabelType;
(function (PricingLabelType) {
    PricingLabelType["UNKNOWN"] = "UNKNOWN";
    PricingLabelType["FREE"] = "FREE";
    PricingLabelType["FREE_TO_INSTALL"] = "FREE_TO_INSTALL";
    PricingLabelType["FREE_TRIAL_DAYS"] = "FREE_TRIAL_DAYS";
    PricingLabelType["FREE_PLAN_AVAILABLE"] = "FREE_PLAN_AVAILABLE";
    PricingLabelType["RECURRING_PRICE"] = "RECURRING_PRICE";
    PricingLabelType["ONE_TIME_PRICE"] = "ONE_TIME_PRICE";
})(PricingLabelType || (PricingLabelType = {}));
export var AppBundleType;
(function (AppBundleType) {
    AppBundleType["DEFAULT"] = "DEFAULT";
    AppBundleType["COUPON"] = "COUPON";
})(AppBundleType || (AppBundleType = {}));
export var BadgeType;
(function (BadgeType) {
    BadgeType["UNKNOWN"] = "UNKNOWN";
    BadgeType["WIX_CHOICE"] = "WIX_CHOICE";
    BadgeType["BETA"] = "BETA";
})(BadgeType || (BadgeType = {}));
export var AppBadgeType;
(function (AppBadgeType) {
    AppBadgeType["UNKNOWN_APP_BADGE"] = "UNKNOWN_APP_BADGE";
    AppBadgeType["WIX_CHOICE"] = "WIX_CHOICE";
    AppBadgeType["PREMIUM_BENEFIT"] = "PREMIUM_BENEFIT";
    AppBadgeType["WIX_SALE"] = "WIX_SALE";
    AppBadgeType["DEV_SALE"] = "DEV_SALE";
    AppBadgeType["BETA"] = "BETA";
})(AppBadgeType || (AppBadgeType = {}));
export var BundleAppType;
(function (BundleAppType) {
    BundleAppType["DEFAULT"] = "DEFAULT";
    BundleAppType["COUPON"] = "COUPON";
})(BundleAppType || (BundleAppType = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["DISCOUNT_TYPE_UNSPECIFIED"] = "DISCOUNT_TYPE_UNSPECIFIED";
    DiscountType["PERCENTAGE"] = "PERCENTAGE";
    DiscountType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
})(DiscountType || (DiscountType = {}));
export var Status;
(function (Status) {
    /** current market listing in the Dev Center. */
    Status["DRAFT"] = "DRAFT";
    /** published market listing in the App Market. */
    Status["PUBLISHED"] = "PUBLISHED";
})(Status || (Status = {}));
//# sourceMappingURL=types.impl.js.map